// Designated Drinks: clean native Shopify nutrition filters
// Keeps exact nutrition metafields available for product pages while hiding raw numeric filter options.

const DD_NUTRITION_FILTERS = new Set(['calories', 'carbs', 'sugar']);
const DD_RAW_NUMBER = /^\s*\d+(?:\.\d+)?\s*$/;

function ddNormalizeText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function ddCleanNutritionFilters(root = document) {
  const filterLists = root.querySelectorAll('.facets__inputs-list[name]');

  filterLists.forEach((list) => {
    const filterName = ddNormalizeText(list.getAttribute('name')).toLowerCase();
    if (!DD_NUTRITION_FILTERS.has(filterName)) return;

    list.querySelectorAll('.facets__inputs-list-item').forEach((item) => {
      const label = ddNormalizeText(item.textContent);

      // Hide plain raw values such as 0, 5, 20, 83, 15.0, 27.0.
      // Keep grouped labels such as 50 calories or less, 0g sugar, 0–5g carbs, 20g+ carbs.
      if (!DD_RAW_NUMBER.test(label)) return;

      item.hidden = true;
      item.setAttribute('data-dd-hidden-raw-nutrition-filter', 'true');

      item.querySelectorAll('input, button, label').forEach((element) => {
        if ('disabled' in element) element.disabled = true;
      });
    });

    const panel = list.closest('.facets__item');
    if (!panel) return;

    const visibleItems = Array.from(list.querySelectorAll('.facets__inputs-list-item')).filter((item) => !item.hidden);
    panel.hidden = visibleItems.length === 0;
  });
}

function ddScheduleFilterCleanup(root = document) {
  window.requestAnimationFrame(() => ddCleanNutritionFilters(root));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ddScheduleFilterCleanup(), { once: true });
} else {
  ddScheduleFilterCleanup();
}

document.addEventListener('shopify:section:load', (event) => ddScheduleFilterCleanup(event.target));
document.addEventListener('collection:update', () => ddScheduleFilterCleanup());
document.addEventListener('search:update', () => ddScheduleFilterCleanup());

const ddFilterObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('.facets__inputs-list') || node.querySelector('.facets__inputs-list')) {
        ddScheduleFilterCleanup();
        return;
      }
    }
  }
});

ddFilterObserver.observe(document.documentElement, { childList: true, subtree: true });
